import React from 'react';
import '../../../App.css';
import './language-menu.css';
import { HideDropdownMenu } from '../../../utils/functions';
// flag
import usukFlag from '../../../icons/US-UK-flag.png';
import dutchFlag from '../../../icons/Netherlands-flag.png';
import { LANGUAGE_OPTIONS } from '../../../utils/common/constants';
import { useAppSelector } from '../../../app/hooks';
import { setLanguageDropdownMenuDisplayed } from '../../../app-slice';

// ------------------------------------------------------------
//
//	This dropdown mimics a droplist listbox, but
//	allows an image to be displayed next to each list item.
//
// ------------------------------------------------------------

export default function LanguageDropdownMenu(args: { buttonHandler: any }) {
  const sLanguageDropdownMenuDisplayed: boolean = useAppSelector(
    (state) => state.app.languageDropdownMenuDisplayed,
  );

  // function that monitors for mouse clicks. we need to add {ref} to the DIV element of the dropdown menu.
  const { ref } = HideDropdownMenu({
    sDropdownDisplayed: sLanguageDropdownMenuDisplayed,
    setDropdownDisplayed: setLanguageDropdownMenuDisplayed,
  });

  //	------------------------------------------------------------
  //
  //	A HTML component that renders a single menu item on the
  //	dropdown menu.
  //
  //	------------------------------------------------------------

  function MenuItem(args: { name: string; text: string; icon?: string; onClick: any }) {
    return (
      <button
        name={'btnLanguage_' + args.name}
        className="dropdown-list-item"
        onClick={args.onClick}
      >
        <div className="dropdown-list-item-text">{args.text}</div>
        <div className="dropdown-list-item-image">
          <img src={args.icon} role="presentation" alt="" width="30" height="16" />
        </div>
      </button>
    );
  } // MenuItem

  return (
    <div
      ref={ref}
      style={{
        display: sLanguageDropdownMenuDisplayed === true ? 'block' : 'none',
        position: 'absolute',
        top: '100%',
        right: '0%',
        border: 'none',
        zIndex: '9',
      }}
    >
      <div className="language-dropdown-menu">
        {LANGUAGE_OPTIONS.map((item, index) => (
          <MenuItem
            key={index}
            name={item.value}
            text={item.label}
            icon={item.icon}
            onClick={args.buttonHandler}
          />
        ))}
      </div>
    </div>
  );
} // LanguageDropdownMenu
